import Vue from 'vue'
import Router from 'vue-router';
import Video from './video';
import Pay from './pay';
import order from './order';
import user from './user';
import article from './article'
import Clinic from './clinic'
import share from './share';
import commentCenter from './comments';
import prod from './prod';
import homecare from './homecare';
import andchongqing from './andcq';
import eTradeUnion from './eTradeUnion';
import promotion from './promotion';
import hospital from './hospital';
import patient from './patient';
import cases from './case';
import * as util from '../lib/util'
import { comment } from 'postcss';
import native from '../lib/native';


Vue.use(Router)

let routes = [
    ...Video,
    ...Pay,
    ...user,
    ...article,
    ...Clinic,
    ...share,
    ...commentCenter,
    ...order,
    ...prod,
    ...homecare,
    ...andchongqing,
    ...eTradeUnion,
    ...promotion,
    ...hospital,
    ...patient,
    ...cases,
    {
        path: '/login',
        name: 'login',
        component: resolve => {
            require(['../views/user/passport/login.vue'], resolve);
        },
        meta: {
            title: '登录'
        }
    },
    {
        path: '/',
        name: 'home',
        component: resolve => {
            require(['../views/index/nindex.vue'], resolve);
        },
        meta: {
            title: '泓华医疗'
        }
    },
    {
        path: '/healthpublic',
        name: 'healthpublic',
        component: resolve => {
          require(['../views/healthPublic/index'], resolve);
        },
        meta: {
            title: '泓华健康公益平台'
        }
    },
    {
        path: '/govideo',
        name: 'govideo',
        component: resolve => {
          require(['../views/healthPublic/govideo'], resolve);
        },
        meta: {
            title: '泓华健康公益平台'
        }
    },
    {
        path: '/downnurse',
        name: 'downnurse',
        component: resolve => {
          require(['../views/healthPublic/downNurse'], resolve);
        },
        meta: {
            title: '泓华健康公益平台'
        }
    },
    {
        path: '/appdown',
        name: 'appdown',
        component: resolve => {
          require(['../views/healthPublic/appdown'], resolve);
        },
        meta: {
            title: '泓华健康公益平台'
        }
    },
	{
	    path: '/ddnurse',
	    name: 'ddnurse',
	    component: resolve => {
	        require(['../views/index/ddnurse.vue'], resolve);
	    },
	    meta: {
	        title: '滴滴护士'
	    }
	},
	{
		path: '/preview',
		name: 'preview',
		component: resolve => {
		    require(['../views/index/nindex.vue'], resolve);
		},
		meta: {
		    title: '泓华医疗'
		}
	},
	{
		path: '/board',
		name: 'board',
		component: resolve => {
		    require(['../views/index/board.vue'], resolve);
		},
		meta: {
		    title: ''
		}
    },
    {
		path: '/doctorfestival',
		name: 'doctorfestival',
		component: resolve => {
		    require(['../views/doctorfestival/index.vue'], resolve);
		},
		meta: {
		    title: '泓华健康公益平台'
		}
    },
    {
		path: '/doctorfestival/nurse',
		name: 'nurse',
		component: resolve => {
		    require(['../views/doctorfestival/doctor.vue'], resolve);
		},
		meta: {
		    title: '泓华健康公益平台'
        }

    },
    {
		path: '/doctorfestival/downnurse',
		name: 'downnurse',
		component: resolve => {
		    require(['../views/doctorfestival/downnurse.vue'], resolve);
		},
		meta: {
		    title: '泓华健康公益平台'
        }
    },
    {
		path: '/healthMonth/index',
		name: 'healthMonth',
		component: resolve => {
		    require(['../views/healthMonth/index.vue'], resolve);
		},
		meta: {
		    title: '泓华健康公益平台'
        }
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: resolve => {
        require(['../views/protocol/agreement.vue'], resolve);
      },
      meta: {
        title: '泓华诊所客户端 服务协议'
      }
    },
    {
        path: '/sixeight',
        name: 'sixeight',
        component: resolve => {
          require(['../views/honghua/sixeight.vue'], resolve);
        },
        meta: {
          title:'泓华健康公益平台'
        }
      },
      {
            path: "/process",
            name: "process",
            component: resolve => {
              require(['../views/index/process.vue'], resolve);
            },
            meta: {
                title: "图文问诊操作流程"
            }
        },
        {
            path: "/statement",
            name: "statement",
            component: resolve => {
              require(['../views/index/statement.vue'], resolve);
            },
            meta: {
                title: "泓华医疗平台医生接诊协议及声明"
            }
        },
        {
            path: "/introduce",
            name: "introduce",
            component: resolve =>{
               require(['../views/index/introduce.vue'], resolve);
            },
            meta: {
                title: "服务介绍"
            }
        },

]

let router = new Router({
    mode: 'history',
    // scrollBehavior: () => ({y: 0}),
    // saveScrollPosition: true,
    routes: routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})

router.beforeEach((to, from, next) => {
    // globle_vue.$vux.loading.show({
    //   text: 'Loading'
    // });
    // meta:{
    //   login:未登录跳转页
    //   needLgin:是否需要登录，def：0 不需要，1需要，
    //   title:页面标题，会覆盖document.title
    // }
    if (to.meta && to.meta.needLogin && util.getACCESS_TOKEN() == '') {
        if (to.meta.login) {
            next({ name: to.meta.login, replace: true });
            return
        } else {
            console.log(util.getBrowser())
            if (util.getBrowser().isapp) {
                native.oasislogin();
                return
            } else {
                next({ name: 'login', replace: true });
                return
            }
        }
    }

    if (to.meta && to.meta.title) {
        document.title = to.meta.title;
    }

    //处方相关 控制逻辑
    //
    // if(from.meta.title === "订单详情" && to.meta.title === "确认订单" ){ // 防止重复下单
    //   next({ path: './list', replace: true });
    //   return
    // }
    //
    // if(from.meta.title === "订单详情" && to.meta.title === "支付详情" ){ // 从支付成功页跳转详情
    //   next({ path: './list', replace: true });
    //   return
    // }
    //
    // if(from.meta.title === "收银台"  && to.meta.title === "确认订单" ){
    //   next({ path: '../orders/list', replace: true })
    //   return
    // }
    // //对订单列表的控制
    // if(to.meta.title === "订单列表" ){
    //   if( from.query && from.query.listStatus ){ //给详情页面相关标识增加
    //     to.query.status = from.query.listStatus;
    //     next(...to);
    //     return
    //   }
    // }

    next()

})

router.afterEach((to, from, next) => {


    //console.log(Vue, '------globle_vue');
    if (Vue.$vux.loading.isVisible()) {


        Vue.$vux.loading.hide()

    }
    //埋点
	if(sessionStorage.source&&!to.query.source){
		to.query.source = sessionStorage.source
	}

    util.sendPV(to.path, to.query)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js